<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/en">Exhibition List</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>Certification Apply
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="MbDevice">
        <div class="homeLeft">
          <div class="UserAccount ml-1">
            <span class="bold">Account :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
          <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
          <div class="expoInfo">
            <p class="bold" name="Exhibition"></p>
            <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
            <p>{{ eExhVenue }}</p>
          </div>
          <p class="clear"></p>
        </div>
      </div>
      <div class="contentBox">
        <h1>Certification Apply</h1>
        <p class="py-3">&nbsp;</p>

        <div>We appreciate your participation in the exhibition.</div>
        <div>
          To download your “Stand Assignment Certificate," please click below:
        </div>

        <div
          class="btn btn-lg btn-primary text-nowrap mt-3 mb-4"
          @click.prevent="downloadCertification"
        >
          Download Certificate
        </div>

        <div>
          *Information on the certificate is generated directly from your
          submitted "Application Form."
        </div>
        <div>
          *For document revisions and inquiry, please contact
          <span v-if="Hanoi">
            <a
              href="mailto:Overseas_Machinery@chanchao.com.tw"
              style="text-decoration: none; color: inherit"
            >
              Overseas_Machinery@chanchao.com.tw
            </a>
          </span>
          <span v-else
            ><a
              href="mailto:op@chanchao.com.tw"
              style="text-decoration: none; color: inherit"
            >
              op@chanchao.com.tw
            </a></span
          >
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  components: {},

  metaInfo() {
    return {
      title: `Certification Apply - Chan Chao Exhibitor's Online Service System`,
    };
  },

  data() {
    return {
      externalLink: "https://www.chanchao.com.tw/",

      UserId: "",
      RegNo: "",

      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
      RegNo2: "",
      Hanoi: false,
    };
  },

  methods: {
    downloadCertification() {
      let vm = this;

      axios
        .get(
          `https://www.chanchao.com.tw/apiExhibitors/Certification/DownloadPDF/${vm.RegNo2}`,
          {
            responseType: "blob",
          },
        )
        .then(function (response) {
          // 判斷是否為 JSON (代表失敗)
          if (response.data.type === "application/json") {
            const reader = new FileReader();
            reader.onload = function () {
              const errorData = JSON.parse(reader.result);
              alert(errorData.Message || "Download Failed");
            };
            reader.readAsText(response.data);
          } else {
            // 成功：建立隱藏連結
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;

            // --- 這裡修改為你指定的固定名稱 ---
            link.setAttribute("download", "Stand Assignment Certificate.pdf");

            document.body.appendChild(link);
            link.click();

            // 清理
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }
        })
        .catch(function (error) {
          console.log(error);
          alert("System busy, please try again later.");
        });
    },
  },

  created() {
    const vm = this;

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let nowPage = location.href;
    let RegNo = nowPage.split("no=")[1];
    vm.RegNo2 = RegNo;

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${RegNo}?lang=en`,
      )
      .then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
        vm.ExhBegin = response.data.Data.ExhBegin;
        vm.ExhEnd = response.data.Data.ExhEnd;
        vm.ExhVenue = response.data.Data.ExhVenue;
        vm.eExhVenue = response.data.Data.eExhVenue;
        let ExhCode = response.data.Data.Original_Code;
        if (
          ExhCode == "HNPlas" ||
          ExhCode == "HNPrintPack" ||
          ExhCode == "FAUIVN"
        ) {
          vm.Hanoi = true;
        } else {
          vm.Hanoi = false;
        }
      });
  },
};
</script>

<style lang="scss">
@import "./../../assets/helper/table.css";
@import "./../../assets/helper/fancybox.css";
</style>
